import { EditorStarterItem } from '../../../items/item-type';
import { getTrackHeight } from '../../../state/items';
import { TrackType } from '../../../state/types';
import { getOffsetOfTrack } from '../../../utils/position-utils';
import {
  getZoneBoundaryIndex,
  ZONE_SEPARATOR_HEIGHT,
} from '../../../utils/zone-utils';

export type TimelineTrackAndLayout = {
  track: TrackType;
  top: number;
  height: number;
};

export const calculateTrackHeights = ({
  tracks,
  items,
}: {
  tracks: TrackType[];
  items: Record<string, EditorStarterItem>;
}): TimelineTrackAndLayout[] => {
  return tracks.map((track, trackIndex) => {
    return {
      track,
      top: getOffsetOfTrack({ trackIndex: trackIndex, tracks, items }),
      height: getTrackHeight({ track, items }),
    };
  });
};

export const getTracksHeight = ({
  tracks,
}: {
  tracks: TimelineTrackAndLayout[];
}) => {
  if (tracks.length === 0) {
    return 0;
  }

  const lastTrack = tracks[tracks.length - 1];
  if (!lastTrack) {
    return 0;
  }
  return lastTrack.top + lastTrack.height;
};

export const getZoneSeparatorTop = ({
  tracks,
}: {
  tracks: TimelineTrackAndLayout[];
}): number | null => {
  const zoneBoundaryIndex = getZoneBoundaryIndex(
    tracks.map((track) => track.track),
  );
  if (zoneBoundaryIndex <= 0 || zoneBoundaryIndex >= tracks.length) {
    return null;
  }

  const firstAudioTrack = tracks[zoneBoundaryIndex];
  if (!firstAudioTrack) {
    return null;
  }

  return firstAudioTrack.top - ZONE_SEPARATOR_HEIGHT;
};
